import { createSelector } from 'reselect';
import PropTypes from 'prop-types';
import { selectApplication } from './selectors';

export const debugSelector = createSelector(
  selectApplication,
  (application) => {
    const debugLevel = application.get('debugLevel');
    const config = {};

    config.translationMode = application.get('translationMode') !== 'normal' && application.get('translationMode');

    config.displayVirtualKeyboard = application.get('displayVirtualKeyboard');

    config.displayPrintFormat = application.get('displayPrintFormat');

    if (debugLevel >= 1 || application.get('disablePriceAnimation')) {
      config.disablePriceAnimation = true;
    }

    return config;
  }
);

export const debugShape = PropTypes.shape({
  translationMode: PropTypes.string,
  disablePriceAnimation: PropTypes.bool,
  displayVirtualKeyboard: PropTypes.bool,
});
